import { render, staticRenderFns } from "./DenounceReportModal.vue?vue&type=template&id=0f2cc1db&scoped=true&"
import script from "./DenounceReportModal.vue?vue&type=script&lang=ts&"
export * from "./DenounceReportModal.vue?vue&type=script&lang=ts&"
import style0 from "./DenounceReportModal.vue?vue&type=style&index=0&id=0f2cc1db&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f2cc1db",
  null
  
)

export default component.exports